//// This file contains 'errors' that we can safely store in the redux store (regular errors are classes and should NOT be stored in redux store)

import { CustomizationObjectType } from "./model-customization-types";

export type LoginError = {
    arePopupsBlocked: boolean;
    errorMessage: string;
}

export const createLoginError = (arePopupsBlocked: boolean, errorMessage: string): LoginError => {
    return { arePopupsBlocked, errorMessage };
}

/** A model customization validation error from backend with information to identify it in UI. */
export type CustomizationValidationError = {
    /** The Redux store object ID for the object that this error is about (e.g. roiId for CustomizationRois) */
    id: string;

    /** Type of the errored object. */
    type: CustomizationObjectType;

    /** A short message about the error. */
    message: string;

    /** A longer, more detailed message about the error. */
    detail: string;

    /** The field of the object that this error is about. */
    field?: string;

    /** More optional context for the error. */
    ctx?: string;
}

/** A daemon validation error from backend with information to identify it in UI. */
export type DaemonValidationError = {
    /** The ID of this error, usually matching the daemon configuration item this errors is for. */
    id: string;

    /** A short message about the error. */
    message: string;

    /** A longer, more detailed message about the error. */
    detail: string;

    /** The field of the object that this error is about. */
    field?: string;

    /** More optional context for the error. */
    ctx?: string;
}
